import { TextField } from '@boltenergy-be/design-system'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'next-i18next/pages'
import { NO_NUMBERS } from 'constants/regex'
import { InputProps } from 'components/inputs/types'
import { getFieldError, getFieldName } from 'components/inputs/utils'

const FirstName = ({ hiddenLabel, parentDotPath, required = true, grid, readonly }: InputProps) => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation', 'common'])

  return (
    <TextField
      {...{ grid, hiddenLabel, readonly }}
      {...register(getFieldName('firstName', parentDotPath), {
        maxLength: {
          value: 40,
          message: t(($) => $.max.string, {
            attribute: t(($) => $.firstName),
            length: 40,
            ns: 'validation'
          })
        },
        minLength: {
          value: 2,
          message: t(($) => $.min.string, {
            attribute: t(($) => $.firstName),
            length: 2,
            ns: 'validation'
          })
        },
        required: {
          value: required,
          message: t(($) => $.required, { ns: 'validation' })
        },
        pattern: {
          value: NO_NUMBERS,
          message: t(($) => $.noNumbers, {
            attribute: t(($) => $.firstName),
            ns: 'validation'
          })
        }
      })}
      error={getFieldError('firstName', parentDotPath, errors)?.message}
      label={t(($) => $.firstName)}
      {...(!required && { optionalText: t(($) => $.optional, { ns: 'common' }) })}
    />
  )
}

export default FirstName
